/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Legacy outcome of a remote MCP server URL verification
 */
export type VerifyURLResult = {
  /**
   * HTTP status code returned by the URL, if any
   */
  httpStatus?: number | undefined;
  /**
   * Human-readable summary of the verification outcome
   */
  message: string;
  /**
   * Whether the URL responded in a way consistent with a remote MCP server
   */
  verified: boolean;
};

/** @internal */
export const VerifyURLResult$inboundSchema: z.ZodMiniType<
  VerifyURLResult,
  unknown
> = z.pipe(
  z.object({
    http_status: z.optional(z.int()),
    message: z.string(),
    verified: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "http_status": "httpStatus",
    });
  }),
);

export function verifyURLResultFromJSON(
  jsonString: string,
): SafeParseResult<VerifyURLResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => VerifyURLResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'VerifyURLResult' from JSON`,
  );
}
